/* ---------------------------------------------------------------------------
   STL 2026 — 4.4  Size guide: CM / INCH toggle

   Serena, 3 Sep 2026. Reference is zimmermann.com, whose guide carries two small
   links above the chart — CM and INCH, 12px, the active one black and the other
   grey — and swaps the measurements in place. She also asked for the values
   themselves to read plainly: `80cm` becomes `80` and `31 1/2"` becomes `31.5`,
   with the unit carried by the toggle instead of repeated in every cell.

   WHY THIS IS DONE IN JS RATHER THAN IN THE PAGE. The chart is a Shopify page
   (`test-size-guide-2`) that Serena edits in the admin, and it is a public URL in
   its own right, so rewriting its markup would change content she owns and could
   affect anywhere else it is rendered. Reading the values out of the DOM leaves
   that page exactly as authored — she can keep editing it normally, in the format
   it is already in, and this keeps working.

   The parse is deliberately forgiving, and anything it cannot read is LEFT ALONE
   rather than blanked: a cell only gets rewritten when both a cm and an inch value
   come out of it cleanly.
   ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var CM = 'stl-units--cm';
  var IN = 'stl-units--in';

  /* `80cm`, `69cm ` -> 80. Trailing spaces and the odd `<span>` wrapper around the
     unit are both handled by taking the digits and nothing else. */
  function parseCm(text) {
    var m = String(text).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return m ? m[1] : null;
  }

  /* `31 1/2"` -> 31.5, `25"` -> 25. Mixed numerals are what the page uses; a plain
     decimal is accepted too in case the copy is ever rewritten. */
  function parseInch(text) {
    var t = String(text).replace(/["”″]/g, ' ').trim();
    var mixed = t.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)/);
    if (mixed) {
      var whole = parseInt(mixed[1], 10);
      var denom = parseInt(mixed[3], 10);
      if (!denom) return null;
      return trim(whole + parseInt(mixed[2], 10) / denom);
    }
    var plain = t.match(/^(\d+(?:\.\d+)?)/);
    return plain ? trim(parseFloat(plain[1])) : null;
  }

  /* 31.5 stays 31.5; 25.0 becomes 25. */
  function trim(n) {
    return String(Math.round(n * 100) / 100);
  }

  function build(root) {
    /* A measurement cell is one holding two paragraphs — cm above inches. The
       conversion table's cells hold a bare number and are skipped, which is what
       keeps AU/US sizes out of the toggle. */
    var cells = Array.prototype.filter.call(
      root.querySelectorAll('td'),
      function (td) {
        return td.querySelectorAll('p').length >= 2;
      }
    );
    if (!cells.length) return false;

    var converted = 0;

    cells.forEach(function (td) {
      var ps = td.querySelectorAll('p');
      var cm = parseCm(ps[0].textContent);
      var inch = parseInch(ps[1].textContent);
      if (cm === null || inch === null) return;

      td.innerHTML =
        '<span class="stl-unit stl-unit--cm">' + cm + '</span>' +
        '<span class="stl-unit stl-unit--in">' + inch + '</span>';
      converted++;
    });

    if (!converted) return false;

    /* The toggle goes on the Fit Guide's heading row, so the label and the control
       share a line the way the size grid shares one with SIZE GUIDE. */
    var section = cells[0].closest('.size-chart-main-down') || root;
    var heading = section.querySelector('.common-head');

    var nav = document.createElement('div');
    nav.className = 'stl-units';
    nav.innerHTML =
      '<button type="button" class="stl-units__btn" data-unit="cm" aria-pressed="true">CM</button>' +
      '<button type="button" class="stl-units__btn" data-unit="in" aria-pressed="false">INCH</button>';

    if (heading) {
      var row = document.createElement('div');
      row.className = 'stl-units-row';
      heading.parentNode.insertBefore(row, heading);
      row.appendChild(heading);
      row.appendChild(nav);
    } else {
      section.insertBefore(nav, section.firstChild);
    }

    root.classList.add(CM);

    nav.addEventListener('click', function (event) {
      var btn = event.target.closest('.stl-units__btn');
      if (!btn) return;
      var wantCm = btn.getAttribute('data-unit') === 'cm';
      root.classList.toggle(CM, wantCm);
      root.classList.toggle(IN, !wantCm);
      Array.prototype.forEach.call(nav.children, function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
    });

    return true;
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.size_guide_content'),
      function (root) {
        if (root.dataset.stlUnits) return;
        if (build(root)) root.dataset.stlUnits = '1';
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
